module.exports = "<pre><code class=\"hljs sh\">$ npm install wovue-focus-trap --save\n</code></pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/installation.md
 ** module id = 9
 ** module chunks = 1
 **/